<mat-dialog-content
  cdkDrag
  cdkDragBoundary=".cdk-overlay-container"
  cdkDragRootElement=".cdk-overlay-pane"
  class="invisibleDragBox not-see-through"
>
  <div>
    <sn-icon cdkDragHandle class="drag-handle">drag_indicator</sn-icon>
  </div>
  <div class="header" *ngIf="this.header">
    <header>{{ this.header }}</header>
  </div>

  <div class="actionCloseBtn">
    <div class="actions" *ngIf="this.actions?.length">
      <sn-action-list [items]="actions" alwaysCollapse></sn-action-list>
    </div>
    <div class="secondaryActions" *ngIf="this.secondaryActions?.length">
      <sn-action-list [items]="secondaryActions"></sn-action-list>
    </div>
    <button class="closeBtn" (click)="close()">
      <sn-icon fontSet="fal" fontIcon="fa-close"></sn-icon>
    </button>
  </div>

  <div class="tertiaryActions" *ngIf="this.tertiaryActions?.length && disableTertiaryActions">
    <sn-action-list [items]="tertiaryActions"></sn-action-list>
  </div>
</mat-dialog-content>
<ng-content></ng-content>
